module.exports = __webpack_public_path__ + "media/images/icons/th-flag-de09e6351e1fcadb7697057bcc2f021f.svg";